import { SettingsService } from './../../../core/services/settings.service';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Connections } from 'src/app/core/interface/auth.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';
import { API_ENDPOINTS } from 'src/app/core/constants/api-endpoints.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';

@Component({
  selector: 'app-block-list',
  templateUrl: './block-list.component.html',
  styleUrls: ['./block-list.component.scss']
})
export class BlocklistComponent implements OnInit {

  blockedConnections: any;
  blockedUsers: any;
  blockedUsersShow: boolean = false;
  blockedUsersShowNonConnected: boolean = false;
  isLoading: boolean = false;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _settingService: SettingsService,
    private spinner: NgxSpinnerService
  ) {
    this.isLoading = true;
  }

  ngOnInit() {
    this._settingService.fetchBlockedConnection().subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.success) {
          this.blockedConnections = response.data.connections;
          if (this.blockedConnections.length > 0) {
            this.blockedUsersShow = true;
            this.blockedConnections.filter((x) => {
              if (x.user.image) {
                x.user.image = API_ENDPOINTS.BASE_URL + x.user.image;
              }
              else {
                x.user.image = 'assets/images/modals/default-user-profile-image.png';
              }
            });
          }
          else {
            this.blockedUsersShow = false;
          }
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {

      });
    this.fetchBlockedUsers();
  }
  closeDialog() {
    this.activeModal.dismiss();
  }

  unblockConnection(userId) {
    const params: Connections = {
      connection: {
        status: 'unblock'
      }
    };
    this.spinner.show();
    this._settingService.unblockConnection(userId, params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = 'Unblocked successfully';
          this.ngOnInit();
        }
      }, (error: any) => {
        this.spinner.hide();
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        this.ngOnInit();
      });
  }

  unblockConnectionNonConnected(userId) {
    const params = {
      contact_id: userId
    };
    this.spinner.show();
    this._settingService.unblockContentAndConnection(params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = 'Unblocked successfully';
          this.ngOnInit();
        }
      }, (error: any) => {
        this.spinner.hide();
        // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        this.ngOnInit();
      });
  }
  // openCreatePublication() {
  //   this.closeDialog();
  //   this.modalService.open(CreatePublicationComponent, { size: 'lg', centered: true });
  // }
  // openUploadPublication() {
  //   this.closeDialog();
  //   this.modalService.open(UploadPublicationComponent, { size: 'lg', centered: true });
  // }
  fetchBlockedUsers() {
    this._settingService.fetchBlockedContentAndConnection().subscribe(
      (response: any) => {

        if (response.success) {
          this.blockedUsers = response.data.blocked_contacts;
          if (this.blockedUsers.length > 0) {
            this.blockedUsersShowNonConnected = true;
            this.blockedUsers.filter((x) => {
              if (x.block.avatar) {
                x.block.avatar = API_ENDPOINTS.BASE_URL + x.block.avatar;
              }
              else {
                x.block.avatar = 'assets/images/modals/default-user-profile-image.png';
              }
            });
          }
          else {
            this.blockedUsersShowNonConnected = false;
          }
        }
        else {
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {

      });
  }
}
